import { WhitepaperDefault } from './WhitepaperDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

WhitepaperDefault.Navbar = LogoLayoutNavbar;

export default WhitepaperDefault;
